import React from 'react';
import InputMask from 'react-input-mask';
import * as s from './styled-input-client';

const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};
const Input = ({
  alert,
  error,
  id,
  name,
  onChange,
  onBlur,
  value,
  emptyField,
  mask,
  placeholder,
  style,
  width,
  height,
  type,
  focused,
  onClick,
  login,
  disabled,
  maxLength,
  titleForm,
  maxwidth,
  noPadding,
  top,
  bottom,
  minWidthTitle,
  maquinaInputMax,
}) => {
  return (
    <s.Container
      focused={focused}
      width={width}
      height={height}
      style={style}
      maxwidth={maxwidth}
      title={placeholder}
      login={login}
      alert={alert}
      error={error}
      emptyField={emptyField}
      noPadding={noPadding}
      top={top}
      bottom={bottom}
      maquinaInputMax={maquinaInputMax}
      disabled={disabled}
    >
      <s.TitleForm minWidthTitle={minWidthTitle}>
        <strong>{titleForm}</strong>
      </s.TitleForm>
      <InputMask
        className="inputMasks"
        onKeyDown={handleKeyDown}
        disabled={disabled}
        id={id}
        name={name}
        mask={mask}
        maxLength={maxLength}
        width={width}
        height={height}
        onClick={onClick}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        type={type || 'text'}
        login={login}
      />
    </s.Container>
  );
};

export default Input;
